
import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useToast } from "@/hooks/use-toast";
import { useAdminCheck } from "@/hooks/useAdminCheck";
import AdminLayout from "@/components/admin/AdminLayout";
import { ElfNameGenerator } from "@/components/tools/elf-name-generator/ElfNameGenerator";
import NameManager from "@/components/admin/tools/elf-name-generator/NameManager";

const ElfNameGeneratorConfig = () => {
  const { isLoading: isAuthLoading } = useAdminCheck();
  const { toast } = useToast();
  
  const [activeTab, setActiveTab] = useState("preview");

  if (isAuthLoading) {
    return <div>Checking authentication...</div>;
  }

  return (
    <AdminLayout 
      title="Elf Name Generator Config" 
      backLink="/admin/tools" 
      backLabel="Back to Tools"
    >
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Elf Name Generator Tool</h1>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="preview">Preview Tool</TabsTrigger>
            <TabsTrigger value="manage">Manage Names</TabsTrigger>
          </TabsList>
          
          <TabsContent value="preview">
            <Card>
              <CardHeader>
                <CardTitle>Tool Preview</CardTitle>
                <CardDescription>
                  Preview how the tool will appear to users when embedded in blog posts
                </CardDescription>
              </CardHeader>
              <CardContent className="bg-gray-50 rounded-b-lg p-6">
                <div className="border rounded-xl overflow-hidden shadow-md bg-white p-4">
                  <ElfNameGenerator />
                </div>
              </CardContent>
            </Card>
            
            <Card className="mt-6">
              <CardHeader>
                <CardTitle>Usage Instructions</CardTitle>
                <CardDescription>
                  How to embed this tool in your blog posts
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div>
                    <h3 className="font-medium mb-2">Use in Blog Posts</h3>
                    <p className="text-gray-600">
                      To include this tool in a blog post, add the following shortcode to your post content:
                    </p>
                    <div className="mt-2 p-3 bg-gray-100 rounded font-mono text-sm">
                      [elf-name-generator]
                    </div>
                  </div>
                  
                  <div>
                    <h3 className="font-medium mb-2">Customization</h3>
                    <p className="text-gray-600">
                      You can customize the appearance of the embedded tool with these parameters:
                    </p>
                    <div className="mt-2 p-3 bg-gray-100 rounded font-mono text-sm">
                      [elf-name-generator title="Custom Title" show_history="false"]
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
          
          <TabsContent value="manage">
            <NameManager />
          </TabsContent>
        </Tabs>
      </div>
    </AdminLayout>
  );
};

export default ElfNameGeneratorConfig;
